import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex/dist/vuex.js'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
